"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaModule = void 0;
const base_1 = require("./base");
class SocialMediaModule extends base_1.SurveyModule {
    constructor(_a) {
        var { color, facebook, instagram, snapchat, tiktok, twitter } = _a, rest = __rest(_a, ["color", "facebook", "instagram", "snapchat", "tiktok", "twitter"]);
        super(rest);
        this._type = "socialmedia";
        this.color = color;
        this.facebook = facebook;
        this.instagram = instagram;
        this.snapchat = snapchat;
        this.tiktok = tiktok;
        this.twitter = twitter;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        return Object.assign({}, this);
    }
    toSurveyConfig() {
        return Object.assign({}, this);
    }
    editProps() {
        return undefined;
    }
}
exports.SocialMediaModule = SocialMediaModule;
//# sourceMappingURL=SocialMedia.js.map